





























import { OptionalType } from 'expangine-runtime';
import { OptionalOptions, OptionalSubs } from './OptionalTypes';
import { getConfirmation } from '../../../app/Confirm';
import { TypeVisuals, TypeVisualInput, TypeSettings } from '../TypeVisuals';
import TypeInputBase from '../TypeInputBase';
import { Preferences, PreferenceCategory } from '../../../app/Preference';


const PREF_REMOVE_OPTIONAL = Preferences.define({
  key: 'optional_clear',
  label: 'Clear optional value without confirmation',
  category: [PreferenceCategory.DESIGN, PreferenceCategory.CONFIRM],
  defaultValue: false,
});


export default TypeInputBase<OptionalType, OptionalOptions, any, OptionalSubs>().extend({
  name: 'Optional',
  computed: {
    hasValue: {
      cache: false,
      get(): boolean {
        return this.value !== undefined && this.value !== null;
      },
    },
    innerTypeVisuals(): TypeVisuals {
      return this.registry.getTypeVisuals(this.type.options);
    },
    innerTypeSettings(): TypeSettings<any> {
      return this.settings.sub.innerType;
    },
    innerTypeInput(): TypeVisualInput<any, any> {
      return this.innerTypeVisuals.inputs[this.innerTypeSettings.input];
    },
    valueName(): string {
      return this.innerTypeInput.getName(this.innerTypeSettings.options) || this.innerTypeVisuals.name(this.type);
    },
    removeIcon(): string {
      return this.settings.options.removeIcon || 'mdi-minus';
    },
    removeLabel(): string {
      return this.settings.options.removeLabel || 'Remove Optional Value';
    },
  },
  methods: {
    async removeValue() {
      if (!await getConfirmation({ pref: PREF_REMOVE_OPTIONAL })) {
        return;
      }
      this.$emit('input', undefined);
    },
    addValue() {
      this.$emit('input', this.type.options.fromJson(this.innerTypeSettings.defaultValue));
      this.$forceUpdate();
    },
  },
});
